import React from 'react'

import { BiMap } from 'react-icons/bi'

import { Services } from '../../../services'

import './stylesLc.css'
import { AuthContext } from '../../../contexts/AuthContext'

export default function Location({ cidade, estado }) {
  const { sttAuthCtx } = React.useContext(AuthContext)
  return (
    <div className='contain-gerencia-local'>
      <div className='contain-mostra-local'>
        <BiMap className='icon-local' size={sttAuthCtx.isMobile ? 20 : 35} />
        <div className='contain-label-city'>
          {cidade ? <h3>{cidade + '/' + Services.RetornaEstados(estado)}</h3> : <h3>Defina sua localização</h3>}
        </div>
      </div>
    </div>
  )
}
